<template>
    <messages :success="success" :error="error" :message="message"></messages>
</template>

<script>

import { mapState } from 'vuex';

export default {

    computed: {
        ...mapState({
            notices: state => state.notices,
        }),

        error() {
            return this.notices.error;
        },

        success() {
            return this.notices.success;
        },

        message() {
            return this.notices.message;
        },
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/SiteNotices.vue